module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "ViewEMIRecord"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printViewEMIRecord()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printViewEMIRecord"
    }
  }, [_c('div', {
    staticClass: "row printing"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('thead', {
    attrs: {
      "tyle": "border-width:2px;"
    }
  }, [_c('td', {
    attrs: {
      "tyle": "border-width:2px;"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "100"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                        "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                        ")])])])]), _vm._v(" "), _c('tbody', [_c('td', [_c('strong', [_vm._v(" Branch : "), (_vm.memberloanplan.branch) ? _c('i', [_vm._v(_vm._s(_vm.memberloanplan.branch.name) + " ")]) : _vm._e(), _c('br'), _vm._v("\n                        Application No : " + _vm._s(_vm.memberloanplan.applicationNo)), _c('br'), _vm._v("\n                        Total Amt : " + _vm._s(_vm.memberloanplan.totalAmt) + " "), _c('br'), _vm._v("\n                        Received Amt : " + _vm._s(_vm.memberloanplan.receivedAmt) + "\n                        ")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [(_vm.memberloanplan.member) ? _c('strong', [_vm._v("Cust Name : " + _vm._s(_vm.memberloanplan.member.name) + " "), _c('br'), _vm._v("\n                        Cust Code : " + _vm._s(_vm.memberloanplan.member.code) + " "), _c('br'), _vm._v("\n                        Cust Mobile : " + _vm._s(_vm.memberloanplan.member.mobile))]) : _vm._e()])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v("LOAN EMI RECORDS")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed",
    attrs: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(ro, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(ro.emiDate) ? _c('i', [_vm._v(_vm._s(_vm._f("myDate")(ro.emiDate)))]) : _vm._e()]), _vm._v(" "), _c('td', [(ro.principal) ? _c('i', [_vm._v(_vm._s(ro.principal))]) : _vm._e()]), _vm._v(" "), _c('td', [(ro.intrest) ? _c('i', [_vm._v(_vm._s(ro.intrest))]) : _vm._e()]), _vm._v(" "), _c('td', [(ro.total) ? _c('i', [_vm._v(_vm._s(ro.total))]) : _vm._e()]), _vm._v(" "), _c('td', [(ro.balance) ? _c('i', [_vm._v(_vm._s(ro.balance))]) : _vm._e()]), _vm._v(" "), _c('td', [(ro.received) ? _c('i', [_vm._v(_vm._s(ro.received))]) : _vm._e()]), _vm._v(" "), _c('td', [(ro.arrear) ? _c('i', [_vm._v(_vm._s(ro.arrear))]) : _vm._e()]), _vm._v(" "), _c('td', [(ro.advance) ? _c('i', [_vm._v(_vm._s(ro.advance))]) : _vm._e()]), _vm._v(" "), _c('td', [(ro.status) ? _c('i', [_vm._v(_vm._s(_vm.emistatus(ro.status)))]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', {
    attrs: {
      "tyle": "border-width:1px;"
    }
  }, [_c('td', {
    attrs: {
      "tyle": "border-width:1px;"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "100"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                        "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                        ")])])])]), _vm._v(" "), _c('tbody', [_c('td', [_c('strong', [_vm._v(" Branch : "), (_vm.memberloanplan.branch) ? _c('i', [_vm._v(_vm._s(_vm.memberloanplan.branch.name) + " ")]) : _vm._e(), _c('br'), _vm._v("\n                        Application No : " + _vm._s(_vm.memberloanplan.applicationNo)), _c('br'), _vm._v("\n                        Total Amt : " + _vm._s(_vm.memberloanplan.totalAmt) + " "), _c('br'), _vm._v("\n                        Received Amt : " + _vm._s(_vm.memberloanplan.receivedAmt) + "\n                        ")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [(_vm.memberloanplan.member) ? _c('strong', [_vm._v("Cust Name : " + _vm._s(_vm.memberloanplan.member.name) + " "), _c('br'), _vm._v("\n                        Cust Code : " + _vm._s(_vm.memberloanplan.member.code) + " "), _c('br'), _vm._v("\n                        Cust Mobile : " + _vm._s(_vm.memberloanplan.member.mobile))]) : _vm._e()])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v("CUSTOMER PAYMENT RECORDS")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-hover",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.rowsMemberCollections), function(payRecord, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', [(payRecord.type === 'panulty') ? _c('i', [_vm._v("penalty")]) : _c('i', [_vm._v(_vm._s(payRecord.type))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("myDate")(payRecord.paymentDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payRecord.amt))]), _vm._v(" "), _c('td', [(payRecord.received_by) ? _c('span', [_vm._v(_vm._s(payRecord.received_by.name))]) : _vm._e()]), _vm._v(" "), _c('td', [(payRecord.branch_ledger) ? _c('span', [_vm._v(_vm._s(payRecord.branch_ledger.ledger.name))]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('td', [_vm._v("Sr.")]), _vm._v(" "), _c('td', [_vm._v("EMI Date")]), _vm._v(" "), _c('td', [_vm._v("Principal")]), _vm._v(" "), _c('td', [_vm._v("Interest")]), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("Balance")]), _vm._v(" "), _c('td', [_vm._v("Received")]), _vm._v(" "), _c('td', [_vm._v("Arrear")]), _vm._v(" "), _c('td', [_vm._v("Advance")]), _vm._v(" "), _c('td', [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', [_vm._v("Sr.")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Pay Date")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Received By")]), _vm._v(" "), _c('th', [_vm._v("Mode")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          CLOSE\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b56dbe2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/PrintEMIRecords.vue
// module id = 850
// module chunks = 0